module.exports = __webpack_public_path__ + "img/login_logo.59546861.png";